var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isVisible)?_c(_setup.NcButton,{attrs:{"size":"small"},on:{"click":_setup.onClick}},[_vm._v("\n\t"+_vm._s(_setup.t('files', 'Search everywhere'))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }